import { getManageAdminUserRoles } from './loginInfo';

const VISITOR = 'manage_admin_user_role|Visitor';
const COMMUNITY_ADMIN = 'manage_admin_user_role|Communityadmin';

const hasRole = (role) => getManageAdminUserRoles().some((el) => el.title === role);

export const isCommunityAdmin = () => hasRole(COMMUNITY_ADMIN);
export const isVisitor = () => hasRole(VISITOR);
